import { createAsyncThunk } from '@reduxjs/toolkit';
import apiInstance from '../../Apis/Axios';
import {FOODIE_MENU_SERVICE} from "../EndPoints";


/**
 * @Author: Susana García Rodríguez
 * @JobTitle : Frontend
 * @Email : sgarcia@ibl.mx
 *
 */
export const CreateExtraMeal = createAsyncThunk('extraMeal/CreateExtraMeal', async (params, { dispatch, getState }) => {
    const response = await apiInstance
        .post(FOODIE_MENU_SERVICE.createExtraMeal, params)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = response;

    return { data, status };
});

export const GetExtraOrders = createAsyncThunk('extraMeal/GetExtraOrdersByAdmin ', async (params, { dispatch, getState }) => {
    const response = await apiInstance
        .post(FOODIE_MENU_SERVICE.getExtraOrdersByAdmin, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status, code } = response;
    return { data, status, code };
});

export const GetActiveExtraOrders = createAsyncThunk('extraMeal/getActiveExtraOrders ', async (params, { dispatch, getState }) => {
    const response = await apiInstance
        .post(FOODIE_MENU_SERVICE.getActiveExtraOrders, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status, code } = response;
    return { data, status, code };
});

export const UpdateExtraOrders = createAsyncThunk('extraMeal/UpdateExtraOrders ', async (params, { dispatch, getState }) => {
    const response = await apiInstance
        .put(FOODIE_MENU_SERVICE.updateExtraOrders, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const GetFoodieUserMenuSelections = createAsyncThunk(
    'extraMeal/GetFoodieUserMenuSelections ',
    async (userId, currentDate, { dispatch, getState }) => {
        const response = await apiInstance
            .get(`/v1/app/get/by-user-id/${userId}/${currentDate}`)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
        const { data, status } = response;
        return { data, status };
    },
);
export const RetrievesAQrCodeBody = createAsyncThunk(
    'extraMeal/RetrievesAQrCodeBody ',
    async (id, { dispatch, getState }) => {
        const response = await apiInstance
            .get(`${FOODIE_MENU_SERVICE.retrievesAQrCodeBody}${id}`)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
        const { data, status } = response;
        return { data, status };
    },
);
export const GetSummaryById = createAsyncThunk('extraMeal/GetSummaryById ', async (id, { dispatch, getState }) => {
    const response = await apiInstance
        .get(`${FOODIE_MENU_SERVICE.getSummaryById}${id}`)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});
export const GetStatusByUserIdActive = createAsyncThunk(
    'extraMeal/getStatusByUserIdActive',
    async ({ userId, isHistory }, { rejectWithValue }) => {
        try {
            const response = await apiInstance.get(
                `${FOODIE_MENU_SERVICE.getStatusByUserIdActive}${userId}/${isHistory}`,
            );
            return { data: response.data, status: response.status };
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);
export const GetStatusByUserIdHistory = createAsyncThunk('extraMeal/GetStatusByUserIdHistory', async (userId, { dispatch, getState }) => {
    const response = await apiInstance
        .get(`${FOODIE_MENU_SERVICE.getStatusByUserIdHistory}${userId}`)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const GetQr = createAsyncThunk('extraMeal/GetQr ', async (id, { dispatch, getState }) => {
    const response = await apiInstance
        .get(`${FOODIE_MENU_SERVICE.getQr}${id}`)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});


export const GetFoodieApprovalByRequestMealId = createAsyncThunk('extraMeal/getFoodieApprovalByRequestMealId ', async (id, { dispatch, getState }) => {
    const response = await apiInstance
        .get(`${FOODIE_MENU_SERVICE.getFoodieApprovalByRequestMealId}${id}`)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});
